<template>
	<div class="bg-gray">
		<div class="content">
			<div class="head-bg" :style="`background: url(${headBg}) no-repeat;backgroundSize:cover;`">
				<div class="container">
					<h2 class="text-white"></h2>
					<p class="text-white"></p>
				</div>
			</div>
		</div>
		<div class="container flex justify-between">
			<a-affix :offset-top="0">
				<div class="tabs">
					<div class="item" :class="currentCompany==item.id?'active':''" @click.stop="tabChange(item.id)" v-for="(item,index) in companyList">
						<a class="flex align-center">
							<div v-if="currentCompany==item.id" class="line2"></div><span class="margin-left-5">{{item.roadshowActivityCompany}}</span>
						</a>
					</div>
				</div>
			</a-affix>
			<div class="contents">
				<div class="item" v-if="details.length==0">
					<a-empty :description="false" />
				</div>
				<div class="item" v-for="(item,index) in details">
					<div class="item-title flex align-center">
						<div class="line"></div> <span class="font-28 margin-left-5">{{item.processes.process}}</span>
					</div>
					<div class="item-body" v-html="item.details.details">
						
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id:"",
				menuPosition:"",
				headBg: require("@/assets/company_bg.png"),
				itemBg: require("@/assets/service_item_bg.png"),
				content: {},
				companyList:[],
				currentCompany:"",
				currentTab:0,
				details:'',
			}
		},
		mounted() {
			document.title = "雄安股权交易所-融资服务";
			this.id = this.$route.query.lastShow;
			this.menuPosition = this.$route.query.menuPosition;
			this.getHeadBg();
			this.getCompany();
		},
		methods: {
			getHeadBg(){
				this.$request({
					url:this.$api.public.getBanner,
					data:{
						menuPosition:this.menuPosition,
						type:1
					}
				}).then((res)=>{
					this.headBg = this.$api.baseUrl+this.$api.imgPath+res.data.result[0].pcImageUrl;
				})
			},
			getCompany(){
				this.$request({
					url:this.$api.roadshow.queryCompanyList,
					data:{roadshowActivityId:this.id}
				}).then((res)=>{
					this.companyList = res.data.result;
					this.currentCompany = this.companyList[0].id;
					this.getCompanyDetails();
				})
			},
			getCompanyDetails(){
				this.$request({
					url:this.$api.roadshow.queryListRpadshowDetails,
					data:{companyId:this.currentCompany}
				}).then((res)=>{
					this.details = res.data.result;
					console.log(this.details);
				})
			},
			
			tabChange(id){
				this.currentCompany = id;
				this.getCompanyDetails();
			}
		}
	}
</script>

<style scoped="scoped">
	.tabs {
		width: 255px;
		padding: 40px;
		background-color: #fff;
		margin-top: 20px;
		margin-bottom: 20px;
		border-radius: 8px;
	}

	.tabs .item {
		padding-bottom: 15px;
		padding-top: 15px;
		border-bottom: 1px solid #F0F2FC;
	}

	.tabs .item:nth-of-type(1) {
		padding-top: 0px;
	}

	.tabs .item a {
		font-size: 18px;
		color: #1A1A1A;
	}

	.tabs .active a {
		font-size: 18px;
	}

	.contents {
		width: 920px;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.contents .item {
		width: 100%;
		padding: 40px;
		background-color: #fff;
		border-radius: 8px;
		margin-bottom: 24px;
	}


	.contents .item .item-title {
		padding-bottom: 24px;
		border-bottom: 1px solid #D9D9D9;
	}

	.contents .item .item-body {
		margin-top: 24px;
	}

	.line {
		width: 4px;
		height: 28px;
		background: linear-gradient(180deg, #1E22AA 0%, #0CB2EC 100%);
		opacity: 1;
		border-radius: 0px;
	}

	.line2 {
		width: 4px;
		height: 24px;
		background: linear-gradient(180deg, #1E22AA 0%, #0CB2EC 100%);
		opacity: 1;
		border-radius: 0px;
	}

	body {
		background-color: #F6F7FC;
	}

	.bg-gray {
		background: #F6F7FC;
	}

	.head-bg {
		width: 100%;
		height: 300px;
	}

	.head-bg h2 {
		font-size: 36px;
		padding-top: 115px;
	}

	.head-bg p {
		font-size: 24px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/roadshow/last.vue